import { render, staticRenderFns } from "./BookingStepViewOrderSummary.vue?vue&type=template&id=42e87ab1"
import script from "./BookingStepViewOrderSummary.vue?vue&type=script&lang=ts"
export * from "./BookingStepViewOrderSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports